export default function MedicineCareSection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Compassionate elderly care"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Warm%20lifestyle%20photography%20of%20a%20smiling%20adult%20daughter%20sitting%20closely%20on%20a%20cream%20sofa%20with%20her%20elderly%20mother%20in%20a%20bright%20cozy%20living%20room%2C%20soft%20natural%20window%20light%2C%20beige%20and%20warm%20neutral%20tones%2C%20genuine%20affectionate%20connection%2C%20gentle%20atmosphere%2C%20high%20detail%20editorial%20photography&width=1600&height=900&seq=medicine-1&orientation=landscape"
        />
        <div className="absolute inset-0 bg-primary-500/45"></div>
      </div>
      <div className="relative z-10 max-w-6xl mx-auto bg-primary-500/45 rounded-2xl p-8 md:p-12">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white/15 rounded-full px-3 py-1.5 mb-5">
            <i className="ri-medicine-bottle-line text-secondary-400 text-xs"></i>
            <span className="text-xs font-semibold text-white uppercase tracking-wider text-shadow-soft">Medicine & Care</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-4 text-shadow-soft">Medication and care, made simple</h2>
          <p className="text-base md:text-lg text-white max-w-2xl mx-auto leading-relaxed text-shadow-soft">
            Managing medications, appointments, and daily care should not be a burden. CareBridge brings everything together in one gentle, easy-to-use system.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-400/20 rounded-lg mb-4">
              <i className="ri-medicine-bottle-line text-primary-300 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2 text-shadow-soft">Medication Reminders</h3>
            <p className="text-sm text-white/90 leading-relaxed text-shadow-soft">
              Gentle reminders with large, clear buttons. Family can see at a glance if medication has been taken.
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-secondary-400/20 rounded-lg mb-4">
              <i className="ri-stethoscope-line text-secondary-300 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2 text-shadow-soft">Appointment Tracking</h3>
            <p className="text-sm text-white/90 leading-relaxed text-shadow-soft">
              Doctor visits, health check-ups, and therapy sessions all tracked in one shared calendar.
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-12 h-12 flex items-center justify-center bg-accent-400/20 rounded-lg mb-4">
              <i className="ri-heart-pulse-line text-accent-300 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2 text-shadow-soft">Health Monitoring</h3>
            <p className="text-sm text-white/90 leading-relaxed text-shadow-soft">
              Daily wellbeing check-ins and health trends help spot changes early so families can respond.
            </p>
          </div>
        </div>
        <div className="text-center mt-12">
          <p className="text-sm text-white/80 mb-4 text-shadow-soft">
            CareBridge supports your family's care routine — it does not replace professional medical advice.
          </p>
          <a href="https://carebridge4elderly.base44.app" target="_blank" rel="nofollow noopener noreferrer" className="bg-secondary-500 text-white font-semibold px-8 py-3.5 rounded-full hover:bg-secondary-600 transition-all cursor-pointer text-sm whitespace-nowrap inline-block">
            Start Caring Together
          </a>
        </div>
      </div>
    </section>
  );
}